import { COLORS_DARK, COLORS_LIGHT } from "../color/raw-value";
export var SHADOWS_LIGHT = {
  XS: '0px 1px 2px 0px rgba(0, 0, 0, 0.04)',
  S: '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
  M: '0px 4px 24px 0px rgba(0, 0, 0, 0.1)',
  L: '0px 8px 32px 0px rgba(0, 0, 0, 0.12)',
  SELECTED: '0px 0px 0px 2px rgba(92, 113, 221, 0.12)'
};
export var SHADOWS_DARK = {
  XS: '0px 1px 2px 0px rgba(0, 0, 0, 0.12)',
  S: '0px 2px 8px 0px rgba(0, 0, 0, 0.24)',
  M: '0px 4px 24px 0px rgba(0, 0, 0, 0.3)',
  L: '0px 8px 32px 0px rgba(0, 0, 0, 0.36)',
  SELECTED: '0px 0px 0px 2px rgba(92, 113, 221, 0.24)'
};
export var SHADOW_BORDERS_LIGHT = {
  XS: "0.5px solid " + COLORS_LIGHT.OVERLAY_LIGHT,
  SELECTED: "1px solid " + COLORS_LIGHT.BRAND1
};
export var SHADOW_BORDERS_DARK = {
  XS: "0.5px solid " + COLORS_DARK.OVERLAY_LIGHT,
  SELECTED: "1px solid " + COLORS_DARK.BRAND1
};